
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8607_3210)"}},[_c('path',{attrs:{"d":"M17.855 6.148a.501.501 0 00-.707-.004l-4.17 4.122A1.97 1.97 0 0012 10c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2c0-.383-.113-.737-.3-1.041l4.152-4.104a.5.5 0 00.004-.707h-.001zM12 13a1.001 1.001 0 010-2 1.001 1.001 0 010 2zm12-1c0 2.436-.726 4.781-2.1 6.783a.5.5 0 11-.824-.566A10.935 10.935 0 0023 12c0-6.065-4.935-11-11-11S1 5.935 1 12c0 2.233.665 4.383 1.924 6.217a.5.5 0 11-.824.566A11.936 11.936 0 010 12C0 5.383 5.383 0 12 0s12 5.383 12 12zm-4.666-3.2c.37.847.588 1.745.648 2.667a.5.5 0 01-.467.532h-.033a.5.5 0 01-.498-.467 6.964 6.964 0 00-.566-2.333.5.5 0 01.916-.4V8.8zM5.016 11.533a.5.5 0 01-.498.467h-.034a.5.5 0 01-.466-.532C4.293 7.28 7.799 4.001 12 4.001c1.112 0 2.188.224 3.2.666a.5.5 0 01-.4.916 6.958 6.958 0 00-2.8-.582c-3.676 0-6.744 2.87-6.984 6.533v-.001zM19 16.5v7a.5.5 0 01-1 0v-7a.5.5 0 011 0zm-5-.5h-1c-.827 0-1.5.673-1.5 1.5v6a.5.5 0 001 0V21H14c1.379 0 2.5-1.121 2.5-2.5S15.379 16 14 16zm0 4h-1.5v-2.5c0-.275.225-.5.5-.5h1c.827 0 1.5.673 1.5 1.5S14.827 20 14 20zm-3.784 3.299a.501.501 0 01-.916.402L7.893 20.5H6v3a.5.5 0 01-1 0v-7a.5.5 0 011 0v3h1.64l1.675-3.23a.5.5 0 11.887.461l-1.558 2.992 1.572 3.576z","fill":"#000C1F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8607_3210"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    